import { render, staticRenderFns } from "./Template-08.vue?vue&type=template&id=bc68f8da&scoped=true&"
import script from "./Template-08.vue?vue&type=script&lang=js&"
export * from "./Template-08.vue?vue&type=script&lang=js&"
import style0 from "./Template-08.vue?vue&type=style&index=0&id=bc68f8da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc68f8da",
  null
  
)

export default component.exports